import { Link } from "react-router-dom";
import me from './assets/me.JPG';

import FilmGrain from './Filmgrain.js';



function Home(props) {
  return (
    <div>
    <div>
      <div style={{
        marginTop: '5%'
      }}>
<h1 style={{
    fontSize: '50px', 
    fontWeight: '100', 
    marginLeft: '5%', 
    letterSpacing: '5px',
    color: props.mode === 'dark' ? '#f1eee6' : '#28282b',
    transition: '.5s'
    }}>{props.greeting} my name is</h1>
  
  

  <h1 style={{
    fontSize: props.viewMode === 'desktop' || props.viewMode === 'tablet' ? '100px' :
    '75px', 
    fontWeight: '100', 
    marginLeft: '5%', 
    letterSpacing: '5px',
    color: props.mode === 'dark' ? '#f1eee6' : '#28282b',
    transition: '.5s'
    }}>DYLAN WATSON</h1>

<h3 style={{
    fontSize: '20px', 
    fontWeight: '100', 
    marginLeft: '5%', 
    letterSpacing: '5px',
    color: props.mode === 'dark' ? '#f1eee6' : '#28282b',
    transition: '.5s'
    }}>web developer / musician / engineer</h3>
  
 

</div>
  
  <div className='bodyContainer'>
  

  </div>
 
  </div>
  </div>
  );
}

  export default Home